import {MODALS_IDS} from '@Components/modal-container';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import type {FormMakerMobileControlModalProps} from './form-maker-mobile-control-modal.types';

export default function FormMakerMobileControlModalNoop(): null {
  return null;
}

// eslint-disable-next-line react-refresh/only-export-components
export const openFormMakerMobileControlModal = (props: FormMakerMobileControlModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.FORM_MAKER_MOBILE_CONTROL_MODAL,
      panelProps: props,
    })
  );
};
